import { type PropsWithChildren, useCallback, useState } from "react";

import type { IEntityPermissions } from "@av/config/api-config/permissions/entity-permissions.interface";
import { FormMetaContext } from "./FormMetaContext";

import type { FormMetaContextType, TrackedFieldProps } from "../types";

/**
 * Meta context holds custom state elements related to the custom form component
 */
export function FormMetaContextContainer({
  children,
  permissions,
}: PropsWithChildren<{ permissions?: IEntityPermissions }>) {
  const [trackedFieldProps, setTrackedFieldProps] = useState<TrackedFieldProps>({});
  const trackProps: FormMetaContextType["trackProps"] = useCallback((field, props) => {
    let finalField = field;

    /***
     * If the list lives under a Form.List element
     * formListParentName has to be appended to the field name
     * This is because antd uses a nested structure to handle these
     */
    if (props.formListParentName && props.formListParentName.length > 0) {
      finalField = `${props.formListParentName.join(".")}.${field}`;
    }

    setTrackedFieldProps((prev) => {
      return {
        ...prev,
        [finalField]: {
          ...prev[finalField],
          label: String(props.label),
          testIdPrefix: props.testIdPrefix,
        },
      };
    });
  }, []);

  return (
    <FormMetaContext value={{ trackProps, trackedFieldProps, permissions }}>
      {children}
    </FormMetaContext>
  );
}
